
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../dashboard/components/Header';
import Sidebar from '../dashboard/components/Sidebar';
import SalesDashboard from './components/SalesDashboard';
import FinancialDashboard from './components/FinancialDashboard';
import StockDashboard from './components/StockDashboard';
import PerformanceDashboard from './components/PerformanceDashboard';

export default function ReportsPage() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [activeTab, setActiveTab] = useState('sales');
  const navigate = useNavigate();

  const tabs = [
    { id: 'sales', label: 'Ventes', icon: 'ri-shopping-cart-line' },
    { id: 'financial', label: 'Finances', icon: 'ri-money-dollar-circle-line' },
    { id: 'stock', label: 'Stocks', icon: 'ri-archive-line' },
    { id: 'performance', label: 'Performance', icon: 'ri-line-chart-line' }
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      <Header onMenuClick={() => setSidebarOpen(!sidebarOpen)} />
      
      <div className="flex">
        <Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />
        
        <main className="flex-1 p-4 sm:p-6 lg:ml-64 pt-20 sm:pt-24">
          <div className="max-w-7xl mx-auto">
            <div className="mb-6 sm:mb-8 flex items-center space-x-4">
              <button
                onClick={() => navigate('/dashboard')}
                className="flex items-center justify-center w-10 h-10 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors cursor-pointer"
                title="Retour au tableau de bord"
              >
                <i className="ri-arrow-left-line text-xl text-gray-600"></i>
              </button>
              <div>
                <h1 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-1 sm:mb-2">Rapports</h1>
                <p className="text-sm sm:text-base text-gray-600">Analyse et reporting de votre activité</p>
              </div>
            </div>

            <div className="bg-white rounded-lg shadow-sm border border-gray-200 mb-4 sm:mb-6">
              <div className="flex border-b border-gray-200 overflow-x-auto">
                {tabs.map((tab) => (
                  <button
                    key={tab.id}
                    onClick={() => setActiveTab(tab.id)}
                    className={`flex items-center space-x-2 px-4 sm:px-6 py-3 sm:py-4 font-medium transition-colors whitespace-nowrap text-sm sm:text-base ${
                      activeTab === tab.id
                        ? 'text-blue-600 border-b-2 border-blue-600'
                        : 'text-gray-600 hover:text-gray-900'
                    }`}
                  >
                    <i className={`${tab.icon} text-lg`}></i>
                    <span>{tab.label}</span>
                  </button>
                ))}
              </div>

              <div className="p-4 sm:p-6">
                {activeTab === 'sales' && <SalesDashboard />}
                {activeTab === 'financial' && <FinancialDashboard />}
                {activeTab === 'stock' && <StockDashboard />}
                {activeTab === 'performance' && <PerformanceDashboard />}
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
}
